import PropTypes from "prop-types";
import { useState, useEffect, useCallback } from "react";
import { useDispatch } from "react-redux";
import { backendAxiosInstance } from "../services/axiosInstances";
// Usage Guide
/**
 * useAxiosFetchData is a custom React hook that fetches data from a specified URL using axios.
 * @param {Object} params - The parameters for the hook.
 * @param {string} params.url - The absolute URL to fetch data from.
 * @param {('get'|'post')} params.method - The HTTP method to use.
 * @param {Object} [params.body=null] - The body of the request.
 * @param {boolean} [params.onLoad=true] - A flag indicating whether to fetch the data when the component mounts.
 * @returns {Object} result - The result object.
 * @returns {Object} result.response - The response data from the server.
 * @returns {string} result.error - An error message.
 * @returns {boolean} result.loading - A flag indicating whether the data is currently being fetched.
 */


const useAxiosFetchData = ({ url, method, body = null, onLoad = true }) => {

    // Props Validation
    PropTypes.checkPropTypes({
        url: PropTypes.string.isRequired,
        method: PropTypes.oneOf(['get', 'post']).isRequired,
    }, { url, method }, 'url and method are required in useAxiosFetchData');


    const [response, setResponse] = useState(null);
    const [error, setError] = useState('');
    const [loading, setLoading] = useState(false);
    useDispatch();
    const fetchData = useCallback(async () => {
        let retVal = null;
        setLoading(true);
        try {
            await backendAxiosInstance({
                url: url,
                method: method,
                data: body,
            }).then((apiResponse) => {
                setResponse(apiResponse.data);
                retVal = apiResponse.data;
                setLoading(false);
            }).catch((err) => {
                setError(err);
                debugger
            });
        } catch (err) {
            setError(err);
            debugger
        }
        return retVal;
    },[body, method, url]);
    useEffect(() => {
        if (onLoad) {
            fetchData({ url, method, body });
        }
    }, [url, method, onLoad, body, fetchData]);
    return { response, error, loading, fetchData };
}
export default useAxiosFetchData;